import { useMutation } from '@tanstack/react-query'
import { bulkOperation } from '../../v3/bulkUpdate'
import { QueryParams } from './types'

export { useBulkOperationPolling } from './useBulkOperationPolling'

export const useCreateBulkRequest = <
  TOperationData extends Record<string, unknown>,
>({
  onMutate,
  onSuccess,
  onError,
}: QueryParams<TOperationData>) => {
  return useMutation({
    mutationFn: ({ operations, params }) =>
      bulkOperation.create({
        params,
        requestBody: {
          data: {
            attributes: {
              operations,
            },
            type: 'bulk_operation',
          },
        },
      }),
    onMutate,
    onSuccess,
    onError,
  })
}
